/*
 *
 * GoogleVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/GoogleVerify';

export const VERIFY_GOOGLE = defineApiActionTypes(`${prefix}/VERIFY_GOOGLE_START`);
